import { render, staticRenderFns } from "./AboutTeamHeader.vue?vue&type=template&id=2470b769&"
import script from "./AboutTeamHeader.vue?vue&type=script&lang=js&"
export * from "./AboutTeamHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports